import angular from 'angular';
import template from './showroom-settings-empty-content-warning.html';

class ShowroomSettingsEmptyContentWarning {
  public trackingCategory: string;
  public trackingAction: string;
  public trackingLabels;

    // Bindings
  public hasProductCatalog;
  public allProductsCrawled;
  public contentType;

  constructor(
        private ShowroomService,
    ) { }

  public $onInit = () => {
    const helpLinkLabel =
            `${this.contentType === 'product' ? 'EmptyProductRecs' : 'EmptyMediaRecs'}:` +
            `${this.hasProductCatalog ? 'HasCatalog' : 'NoCatalog'}`;
    this.trackingCategory = this.ShowroomService.getTrackingCategory();
    this.trackingAction = this.ShowroomService.getTrackingAction();
    this.trackingLabels = {
      helpLinkClicked: `HelpLinkClicked=${helpLinkLabel}`,
    };
  }
}

angular.module('uia').component('showroomSettingsEmptyContentWarning', {
  bindings: {
    hasProductCatalog: '<',
    allProductsCrawled: '<',
    contentType: '<',
  },
  template,
  controller: [
    'ShowroomService',
    ShowroomSettingsEmptyContentWarning,
  ],
});
